'use strict';
const $ = jQuery.noConflict();

$(function() {
	const accordionBlock = {
		classActive: 'is-active',

		init: function() {
			this.cacheDOM();

			if (!this.$items.length) {
				return;
			}

			this.bindEvents();
		},

		cacheDOM: function() {
			this.$section = $('.js-accordion-block');
			this.$items = this.$section.find('.js-accordion-block-item');
		},

		bindEvents: function() {
			this.$items.find('.js-accordion-block-trigger').on('click', this.handleToggle.bind(this));
		},

		handleToggle: function(e) {
			const $trigger = $(e.currentTarget);
			const $item = $trigger.closest('.js-accordion-block-item');
			const wasActive = $item.hasClass(this.classActive);

			this.$items.not($item).each((i, item) => {
				this.closeItem($(item));
			});

			if (wasActive) {
				this.closeItem($item);
			} else {
				this.openItem($item);
			}
		},

		openItem: function($item) {
			const $panel = $item.find('.js-accordion-block-panel');

			$item.addClass(this.classActive);
			$item.find('.js-accordion-block-trigger').attr('aria-expanded', 'true');
			$panel.attr('aria-hidden', 'false');
			$panel.stop(true, true).slideDown(300);
		},

		closeItem: function($item) {
			const $panel = $item.find('.js-accordion-block-panel');

			$item.removeClass(this.classActive);
			$item.find('.js-accordion-block-trigger').attr('aria-expanded', 'false');
			$panel.attr('aria-hidden', 'true');
			$panel.stop(true, true).slideUp(300);
		},
	};

	accordionBlock.init();
});
